module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      General UI\n      "), _c('small', [_vm._v("Preview of UI elements")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("UI")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("General")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-default color-palette-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-tag"
  }), _vm._v(" Color Palette")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-md-2"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Primary")]), _vm._v(" "), _c('div', {
    staticClass: "color-palette-set"
  }, [_c('div', {
    staticClass: "bg-light-blue disabled color-palette"
  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-light-blue color-palette"
  }, [_c('span', [_vm._v("#3c8dbc")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-light-blue-active color-palette"
  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-2"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Info")]), _vm._v(" "), _c('div', {
    staticClass: "color-palette-set"
  }, [_c('div', {
    staticClass: "bg-aqua disabled color-palette"
  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-aqua color-palette"
  }, [_c('span', [_vm._v("#00c0ef")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-aqua-active color-palette"
  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-2"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Success")]), _vm._v(" "), _c('div', {
    staticClass: "color-palette-set"
  }, [_c('div', {
    staticClass: "bg-green disabled color-palette"
  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-green color-palette"
  }, [_c('span', [_vm._v("#00a65a")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-green-active color-palette"
  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-2"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Warning")]), _vm._v(" "), _c('div', {
    staticClass: "color-palette-set"
  }, [_c('div', {
    staticClass: "bg-yellow disabled color-palette"
  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-yellow color-palette"
  }, [_c('span', [_vm._v("#f39c12")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-yellow-active color-palette"
  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-2"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Danger")]), _vm._v(" "), _c('div', {
    staticClass: "color-palette-set"
  }, [_c('div', {
    staticClass: "bg-red disabled color-palette"
  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-red color-palette"
  }, [_c('span', [_vm._v("#f56954")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-red-active color-palette"
  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-2"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Gray")]), _vm._v(" "), _c('div', {
    staticClass: "color-palette-set"
  }, [_c('div', {
    staticClass: "bg-gray disabled color-palette"
  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-gray color-palette"
  }, [_c('span', [_vm._v("#d2d6de")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-gray-active color-palette"
  }, [_c('span', [_vm._v("Active")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-md-2"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Navy")]), _vm._v(" "), _c('div', {
    staticClass: "color-palette-set"
  }, [_c('div', {
    staticClass: "bg-navy disabled color-palette"
  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-navy color-palette"
  }, [_c('span', [_vm._v("#001F3F")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-navy-active color-palette"
  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-2"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Teal")]), _vm._v(" "), _c('div', {
    staticClass: "color-palette-set"
  }, [_c('div', {
    staticClass: "bg-teal disabled color-palette"
  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-teal color-palette"
  }, [_c('span', [_vm._v("#39CCCC")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-teal-active color-palette"
  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-2"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('div', {
    staticClass: "color-palette-set"
  }, [_c('div', {
    staticClass: "bg-purple disabled color-palette"
  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-purple color-palette"
  }, [_c('span', [_vm._v("#605ca8")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-purple-active color-palette"
  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-2"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Orange")]), _vm._v(" "), _c('div', {
    staticClass: "color-palette-set"
  }, [_c('div', {
    staticClass: "bg-orange disabled color-palette"
  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-orange color-palette"
  }, [_c('span', [_vm._v("#ff851b")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-orange-active color-palette"
  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-2"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Maroon")]), _vm._v(" "), _c('div', {
    staticClass: "color-palette-set"
  }, [_c('div', {
    staticClass: "bg-maroon disabled color-palette"
  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-maroon color-palette"
  }, [_c('span', [_vm._v("#D81B60")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-maroon-active color-palette"
  }, [_c('span', [_vm._v("Active")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-md-2"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Black")]), _vm._v(" "), _c('div', {
    staticClass: "color-palette-set"
  }, [_c('div', {
    staticClass: "bg-black disabled color-palette"
  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-black color-palette"
  }, [_c('span', [_vm._v("#111111")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-black-active color-palette"
  }, [_c('span', [_vm._v("Active")])])])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Alerts and Callouts")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Alerts")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "alert alert-danger alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', [_c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" Alert!")]), _vm._v("\n              Danger alert preview. This alert is dismissable. A wonderful serenity has taken possession of my entire\n              soul, like these sweet mornings of spring which I enjoy with my whole heart.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', [_c('i', {
    staticClass: "icon fa fa-info"
  }), _vm._v(" Alert!")]), _vm._v("\n              Info alert preview. This alert is dismissable.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-warning alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Alert!")]), _vm._v("\n              Warning alert preview. This alert is dismissable.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-success alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" Alert!")]), _vm._v("\n              Success alert preview. This alert is dismissable.\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-bullhorn"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Callouts")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "callout callout-danger"
  }, [_c('h4', [_vm._v("I am a danger callout!")]), _vm._v(" "), _c('p', [_vm._v("There is a problem that we need to fix. A wonderful serenity has taken possession of my entire soul,\n                like these sweet mornings of spring which I enjoy with my whole heart.")])]), _vm._v(" "), _c('div', {
    staticClass: "callout callout-info"
  }, [_c('h4', [_vm._v("I am an info callout!")]), _vm._v(" "), _c('p', [_vm._v("Follow the steps to continue to payment.")])]), _vm._v(" "), _c('div', {
    staticClass: "callout callout-warning"
  }, [_c('h4', [_vm._v("I am a warning callout!")]), _vm._v(" "), _c('p', [_vm._v("This is a yellow callout.")])]), _vm._v(" "), _c('div', {
    staticClass: "callout callout-success"
  }, [_c('h4', [_vm._v("I am a success callout!")]), _vm._v(" "), _c('p', [_vm._v("This is a green callout.")])])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("AdminLTE Custom Tabs")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab"
    }
  }, [_vm._v("Tab 1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#tab_2",
      "data-toggle": "tab"
    }
  }, [_vm._v("Tab 2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#tab_3",
      "data-toggle": "tab"
    }
  }, [_vm._v("Tab 3")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    }
  }, [_vm._v("\n                Dropdown "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('li', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "text-muted",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab_1"
    }
  }, [_c('b', [_vm._v("How to use:")]), _vm._v(" "), _c('p', [_vm._v("Exactly like the original bootstrap tabs except you should use\n                the custom wrapper "), _c('code', [_vm._v(".nav-tabs-custom")]), _vm._v(" to achieve this style.")]), _vm._v("\n              A wonderful serenity has taken possession of my entire soul,\n              like these sweet mornings of spring which I enjoy with my whole heart.\n              I am alone, and feel the charm of existence in this spot,\n              which was created for the bliss of souls like mine. I am so happy,\n              my dear friend, so absorbed in the exquisite sense of mere tranquil existence,\n              that I neglect my talents. I should be incapable of drawing a single stroke\n              at the present moment; and yet I feel that I never was a greater artist than now.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_2"
    }
  }, [_vm._v("\n              The European languages are members of the same family. Their separate existence is a myth.\n              For science, music, sport, etc, Europe uses the same vocabulary. The languages only differ\n              in their grammar, their pronunciation and their most common words. Everyone realizes why a\n              new common language would be desirable: one could refuse to pay expensive translators. To\n              achieve this, it would be necessary to have uniform grammar, pronunciation and more common\n              words. If several languages coalesce, the grammar of the resulting language is more simple\n              and regular than that of the individual languages.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_3"
    }
  }, [_vm._v("\n              Lorem Ipsum is simply dummy text of the printing and typesetting industry.\n              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,\n              when an unknown printer took a galley of type and scrambled it to make a type specimen book.\n              It has survived not only five centuries, but also the leap into electronic typesetting,\n              remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset\n              sheets containing Lorem Ipsum passages, and more recently with desktop publishing software\n              like Aldus PageMaker including versions of Lorem Ipsum.\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs pull-right"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab_1-1",
      "data-toggle": "tab"
    }
  }, [_vm._v("Tab 1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#tab_2-2",
      "data-toggle": "tab"
    }
  }, [_vm._v("Tab 2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#tab_3-2",
      "data-toggle": "tab"
    }
  }, [_vm._v("Tab 3")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    }
  }, [_vm._v("\n                Dropdown "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('li', {
    staticClass: "pull-left header"
  }, [_c('i', {
    staticClass: "fa fa-th"
  }), _vm._v(" Custom Tabs")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab_1-1"
    }
  }, [_c('b', [_vm._v("How to use:")]), _vm._v(" "), _c('p', [_vm._v("Exactly like the original bootstrap tabs except you should use\n                the custom wrapper "), _c('code', [_vm._v(".nav-tabs-custom")]), _vm._v(" to achieve this style.")]), _vm._v("\n              A wonderful serenity has taken possession of my entire soul,\n              like these sweet mornings of spring which I enjoy with my whole heart.\n              I am alone, and feel the charm of existence in this spot,\n              which was created for the bliss of souls like mine. I am so happy,\n              my dear friend, so absorbed in the exquisite sense of mere tranquil existence,\n              that I neglect my talents. I should be incapable of drawing a single stroke\n              at the present moment; and yet I feel that I never was a greater artist than now.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_2-2"
    }
  }, [_vm._v("\n              The European languages are members of the same family. Their separate existence is a myth.\n              For science, music, sport, etc, Europe uses the same vocabulary. The languages only differ\n              in their grammar, their pronunciation and their most common words. Everyone realizes why a\n              new common language would be desirable: one could refuse to pay expensive translators. To\n              achieve this, it would be necessary to have uniform grammar, pronunciation and more common\n              words. If several languages coalesce, the grammar of the resulting language is more simple\n              and regular than that of the individual languages.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_3-2"
    }
  }, [_vm._v("\n              Lorem Ipsum is simply dummy text of the printing and typesetting industry.\n              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,\n              when an unknown printer took a galley of type and scrambled it to make a type specimen book.\n              It has survived not only five centuries, but also the leap into electronic typesetting,\n              remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset\n              sheets containing Lorem Ipsum passages, and more recently with desktop publishing software\n              like Aldus PageMaker including versions of Lorem Ipsum.\n            ")])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Progress Bars")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Progress Bars Different Sizes")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', [_c('code', [_vm._v(".progress")])]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-primary progress-bar-striped",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "40",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("40% Complete (success)")])])]), _vm._v(" "), _c('p', [_vm._v("Class: "), _c('code', [_vm._v(".sm")])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-sm active"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success progress-bar-striped",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("20% Complete")])])]), _vm._v(" "), _c('p', [_vm._v("Class: "), _c('code', [_vm._v(".xs")])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-warning progress-bar-striped",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("60% Complete (warning)")])])]), _vm._v(" "), _c('p', [_vm._v("Class: "), _c('code', [_vm._v(".xxs")])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xxs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-danger progress-bar-striped",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("60% Complete (warning)")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Progress bars")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "40",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("40% Complete (success)")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("20% Complete")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-yellow",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("60% Complete (warning)")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-red",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "80",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("80% Complete")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Vertical Progress Bars Different Sizes")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body text-center"
  }, [_c('p', [_vm._v("By adding the class "), _c('code', [_vm._v(".vertical")]), _vm._v(" and "), _c('code', [_vm._v(".progress-sm")]), _vm._v(", "), _c('code', [_vm._v(".progress-xs")]), _vm._v(" or\n              "), _c('code', [_vm._v(".progress-xxs")]), _vm._v(" we achieve:")]), _vm._v(" "), _c('div', {
    staticClass: "progress vertical active"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-primary progress-bar-striped",
    staticStyle: {
      "height": "40%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "40",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("40%")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress vertical progress-sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("100%")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress vertical progress-xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-warning progress-bar-striped",
    staticStyle: {
      "height": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("60%")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress vertical progress-xxs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-info progress-bar-striped",
    staticStyle: {
      "height": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("60%")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Vertical Progress bars")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body text-center"
  }, [_c('p', [_vm._v("By adding the class "), _c('code', [_vm._v(".vertical")]), _vm._v(" we achieve:")]), _vm._v(" "), _c('div', {
    staticClass: "progress vertical"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    staticStyle: {
      "height": "40%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "40",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("40%")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress vertical"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    staticStyle: {
      "height": "20%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("20%")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress vertical"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-yellow",
    staticStyle: {
      "height": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("60%")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress vertical"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-red",
    staticStyle: {
      "height": "80%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "80",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("80%")])])])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Bootstrap Accordion & Carousel")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Collapsible Accordion")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-group",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h4', {
    staticClass: "box-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseOne"
    }
  }, [_vm._v("\n                      Collapsible Group Item #1\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n                    Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3\n                    wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum\n                    eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla\n                    assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred\n                    nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer\n                    farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus\n                    labore sustainable VHS.\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box box-danger"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h4', {
    staticClass: "box-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseTwo"
    }
  }, [_vm._v("\n                      Collapsible Group Danger\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n                    Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3\n                    wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum\n                    eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla\n                    assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred\n                    nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer\n                    farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus\n                    labore sustainable VHS.\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box box-success"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h4', {
    staticClass: "box-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseThree"
    }
  }, [_vm._v("\n                      Collapsible Group Success\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n                    Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3\n                    wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum\n                    eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla\n                    assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred\n                    nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer\n                    farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus\n                    labore sustainable VHS.\n                  ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Carousel")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "carousel-example-generic",
      "data-ride": "carousel"
    }
  }, [_c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#carousel-example-generic",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carousel-example-generic",
      "data-slide-to": "1"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carousel-example-generic",
      "data-slide-to": "2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner"
  }, [_c('div', {
    staticClass: "item active"
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/900x500/39CCCC/ffffff&text=I+Love+Bootstrap",
      "alt": "First slide"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption"
  }, [_vm._v("\n                    First Slide\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/900x500/3c8dbc/ffffff&text=I+Love+Bootstrap",
      "alt": "Second slide"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption"
  }, [_vm._v("\n                    Second Slide\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/900x500/f39c12/ffffff&text=I+Love+Bootstrap",
      "alt": "Third slide"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption"
  }, [_vm._v("\n                    Third Slide\n                  ")])])]), _vm._v(" "), _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "href": "#carousel-example-generic",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "href": "#carousel-example-generic",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "fa fa-angle-right"
  })])])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Typography")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-text-width"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Headlines")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h1', [_vm._v("h1. Bootstrap heading")]), _vm._v(" "), _c('h2', [_vm._v("h2. Bootstrap heading")]), _vm._v(" "), _c('h3', [_vm._v("h3. Bootstrap heading")]), _vm._v(" "), _c('h4', [_vm._v("h4. Bootstrap heading")]), _vm._v(" "), _c('h5', [_vm._v("h5. Bootstrap heading")]), _vm._v(" "), _c('h6', [_vm._v("h6. Bootstrap heading")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-text-width"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Text Emphasis")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', {
    staticClass: "lead"
  }, [_vm._v("Lead to emphasize importance")]), _vm._v(" "), _c('p', {
    staticClass: "text-green"
  }, [_vm._v("Text green to emphasize success")]), _vm._v(" "), _c('p', {
    staticClass: "text-aqua"
  }, [_vm._v("Text aqua to emphasize info")]), _vm._v(" "), _c('p', {
    staticClass: "text-light-blue"
  }, [_vm._v("Text light blue to emphasize info (2)")]), _vm._v(" "), _c('p', {
    staticClass: "text-red"
  }, [_vm._v("Text red to emphasize danger")]), _vm._v(" "), _c('p', {
    staticClass: "text-yellow"
  }, [_vm._v("Text yellow to emphasize warning")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Text muted to emphasize general")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-text-width"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Block Quotes")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('blockquote', [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]), _vm._v(" "), _c('small', [_vm._v("Someone famous in "), _c('cite', {
    attrs: {
      "title": "Source Title"
    }
  }, [_vm._v("Source Title")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-text-width"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Block Quotes Pulled Right")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body clearfix"
  }, [_c('blockquote', {
    staticClass: "pull-right"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]), _vm._v(" "), _c('small', [_vm._v("Someone famous in "), _c('cite', {
    attrs: {
      "title": "Source Title"
    }
  }, [_vm._v("Source Title")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-text-width"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Unordered List")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('ul', [_c('li', [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', [_vm._v("Consectetur adipiscing elit")]), _vm._v(" "), _c('li', [_vm._v("Integer molestie lorem at massa")]), _vm._v(" "), _c('li', [_vm._v("Facilisis in pretium nisl aliquet")]), _vm._v(" "), _c('li', [_vm._v("Nulla volutpat aliquam velit\n                "), _c('ul', [_c('li', [_vm._v("Phasellus iaculis neque")]), _vm._v(" "), _c('li', [_vm._v("Purus sodales ultricies")]), _vm._v(" "), _c('li', [_vm._v("Vestibulum laoreet porttitor sem")]), _vm._v(" "), _c('li', [_vm._v("Ac tristique libero volutpat at")])])]), _vm._v(" "), _c('li', [_vm._v("Faucibus porta lacus fringilla vel")]), _vm._v(" "), _c('li', [_vm._v("Aenean sit amet erat nunc")]), _vm._v(" "), _c('li', [_vm._v("Eget porttitor lorem")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-text-width"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Ordered Lists")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('ol', [_c('li', [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', [_vm._v("Consectetur adipiscing elit")]), _vm._v(" "), _c('li', [_vm._v("Integer molestie lorem at massa")]), _vm._v(" "), _c('li', [_vm._v("Facilisis in pretium nisl aliquet")]), _vm._v(" "), _c('li', [_vm._v("Nulla volutpat aliquam velit\n                "), _c('ol', [_c('li', [_vm._v("Phasellus iaculis neque")]), _vm._v(" "), _c('li', [_vm._v("Purus sodales ultricies")]), _vm._v(" "), _c('li', [_vm._v("Vestibulum laoreet porttitor sem")]), _vm._v(" "), _c('li', [_vm._v("Ac tristique libero volutpat at")])])]), _vm._v(" "), _c('li', [_vm._v("Faucibus porta lacus fringilla vel")]), _vm._v(" "), _c('li', [_vm._v("Aenean sit amet erat nunc")]), _vm._v(" "), _c('li', [_vm._v("Eget porttitor lorem")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-text-width"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Unstyled List")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', [_vm._v("Consectetur adipiscing elit")]), _vm._v(" "), _c('li', [_vm._v("Integer molestie lorem at massa")]), _vm._v(" "), _c('li', [_vm._v("Facilisis in pretium nisl aliquet")]), _vm._v(" "), _c('li', [_vm._v("Nulla volutpat aliquam velit\n                "), _c('ul', [_c('li', [_vm._v("Phasellus iaculis neque")]), _vm._v(" "), _c('li', [_vm._v("Purus sodales ultricies")]), _vm._v(" "), _c('li', [_vm._v("Vestibulum laoreet porttitor sem")]), _vm._v(" "), _c('li', [_vm._v("Ac tristique libero volutpat at")])])]), _vm._v(" "), _c('li', [_vm._v("Faucibus porta lacus fringilla vel")]), _vm._v(" "), _c('li', [_vm._v("Aenean sit amet erat nunc")]), _vm._v(" "), _c('li', [_vm._v("Eget porttitor lorem")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-text-width"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Description")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('dl', [_c('dt', [_vm._v("Description lists")]), _vm._v(" "), _c('dd', [_vm._v("A description list is perfect for defining terms.")]), _vm._v(" "), _c('dt', [_vm._v("Euismod")]), _vm._v(" "), _c('dd', [_vm._v("Vestibulum id ligula porta felis euismod semper eget lacinia odio sem nec elit.")]), _vm._v(" "), _c('dd', [_vm._v("Donec id elit non mi porta gravida at eget metus.")]), _vm._v(" "), _c('dt', [_vm._v("Malesuada porta")]), _vm._v(" "), _c('dd', [_vm._v("Etiam porta sem malesuada magna mollis euismod.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-text-width"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Description Horizontal")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Description lists")]), _vm._v(" "), _c('dd', [_vm._v("A description list is perfect for defining terms.")]), _vm._v(" "), _c('dt', [_vm._v("Euismod")]), _vm._v(" "), _c('dd', [_vm._v("Vestibulum id ligula porta felis euismod semper eget lacinia odio sem nec elit.")]), _vm._v(" "), _c('dd', [_vm._v("Donec id elit non mi porta gravida at eget metus.")]), _vm._v(" "), _c('dt', [_vm._v("Malesuada porta")]), _vm._v(" "), _c('dd', [_vm._v("Etiam porta sem malesuada magna mollis euismod.")]), _vm._v(" "), _c('dt', [_vm._v("Felis euismod semper eget lacinia")]), _vm._v(" "), _c('dd', [_vm._v("Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo\n                sit amet risus.\n              ")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70e82856!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ui/General.vue
// module id = 2011
// module chunks = 1